import { render } from "./CallingIcon.vue?vue&type=template&id=2da1164a"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/CallingIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2da1164a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2da1164a', __exports__)) {
    api.reload('2da1164a', __exports__)
  }
  
  module.hot.accept("./CallingIcon.vue?vue&type=template&id=2da1164a", () => {
    api.rerender('2da1164a', render)
  })

}


export default __exports__